import * as Icons from "lucide-react";
import { BENEFITS } from "../../content";
import { Eyebrow, Reveal } from "./Primitives";

export const Benefits = () => (
  <section id="konzept" data-testid="benefits-section" className="bg-ice py-24 sm:py-32">
    <div className="mx-auto grid max-w-[1400px] gap-16 px-5 sm:px-8 lg:grid-cols-12 lg:px-12">
      <div className="lg:col-span-5">
        <div className="lg:sticky lg:top-32">
          <Reveal>
            <Eyebrow>Unser Konzept</Eyebrow>
            <h2 className="mt-6 text-4xl font-extrabold leading-[1.05] tracking-[-0.02em] text-navy sm:text-5xl">
              Jedes Kind lernt anders. <span className="font-light italic text-sky-700">Wir begleiten es individuell.</span>
            </h2>
            <p className="mt-6 max-w-md text-base leading-relaxed text-slate-600 md:text-lg">
              Schwimmen lernen ist mehr als Technik. Es geht um Vertrauen – in das Wasser, in die eigenen Fähigkeiten und in die Menschen am Beckenrand.
            </p>
          </Reveal>
        </div>
      </div>
      <ol className="grid gap-px overflow-hidden border border-navy/10 bg-navy/10 sm:grid-cols-2 lg:col-span-7">
        {BENEFITS.map((b, i) => {
          const Icon = Icons[b.icon];
          return (
            <li key={b.title} data-testid={`benefit-${i + 1}`} className="benefit group bg-ice p-8 transition-colors duration-500 hover:bg-white sm:p-10">
              <Reveal delay={(i % 2) * 0.08}>
                <div className="flex items-center justify-between">
                  <Icon className="h-6 w-6 text-sky-700 transition-transform duration-500 group-hover:-translate-y-1" strokeWidth={1.5} />
                  <span className="text-xs font-bold text-slate-500">0{i + 1}</span>
                </div>
                <h3 className="mt-8 text-xl font-bold text-navy">{b.title}</h3>
                <p className="mt-3 text-sm leading-relaxed text-slate-600 sm:text-base">{b.text}</p>
              </Reveal>
            </li>
          );
        })}
      </ol>
    </div>
  </section>
);
